// extracted by mini-css-extract-plugin
export default {"noDrop":"src-components-base-FileReceiver-style__Qdoeu__noDrop"};